'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _searchBox = require('./searchBox.html');

var _searchBox2 = _interopRequireDefault(_searchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchBox = {

    bindings: {
        placeholderText: '@',
        onSearchChanged: '&',
        onSearchCleared: '&',
        searchText: '=?'
    },

    template: _searchBox2.default,

    controller: function controller() {

        this.searchChanged = function () {
            this.onSearchChanged({ text: this.searchText });
        };

        this.clearSearchBox = function () {
            console.log('cleared files-insearch');
            this.searchText = '';
            this.onSearchCleared();
        };
    }

};

exports.default = searchBox;


/** WEBPACK FOOTER **
 ** ./src/app/directives/searchBox/searchBox.js
 **/